import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import * as firebase from 'firebase/app';
import { DataServiceService } from '../../services/common/data-service.service';
import { LoaderService } from '../../services/common/loader.service';
import { PersistentStorageService } from '../../services/common/persistent-storage.service';
import { USER_KEY } from '../../constants/user-constants';
import { HeaderService } from '../../services/common/header.service';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../services/common/common.service';
import { EVENT, LOGTYPE } from '../../constants/logging';
import * as jwt_decode from 'jwt-decode';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: [ './home.component.scss' ]
})
export class HomeComponent implements OnInit {
	public currentUser;
	staffData: any;
	isLoading = false;
	isStaffHeaderVisible = true;

	constructor(
		private readonly dataService: DataServiceService,
		private readonly loaderService: LoaderService,
		private readonly persistentStorageService: PersistentStorageService,
		private readonly headerService: HeaderService,
		private readonly common: CommonService
	) {}

	ngOnInit() {
		this.loaderService.show();
		this.headerService.isStaffHeaderVisible.subscribe((isVisible) => (this.isStaffHeaderVisible = isVisible));
		this.loaderService.isLoading.subscribe((isLoading) => (this.isLoading = isLoading));
		firebase.auth().onAuthStateChanged((user) => {
			if (user) {
				this.currentUser = user;
				this.persistentStorageService.setLocalStorage(USER_KEY.CURRENT_STAFF_EMAIL, user.email.toLowerCase());
				// tslint:disable-next-line: max-line-length
				const description = `[${this.currentUser.email}] is now Logged In.`;
				this.common.addtoStack(this.currentUser.email, EVENT.LOGIN, LOGTYPE.INFO, description);
				this.common.auditLog(
					user.email.toLowerCase(),
					this.currentUser['uid'],
					'STAFF',
					'AFTER EXECUTION',
					description,
					'onAuthStateChanged'
				);
				firebase.auth().getRedirectResult().then((result) => {
					if (result && result.credential) {
						sessionStorage.setItem('auth_token', result.credential['idToken']);
						sessionStorage.setItem('token', result.credential['accessToken']);
						this.currentUser.decodedAuthToken = jwt_decode(sessionStorage.getItem('auth_token'));
					}
					if (sessionStorage.getItem('auth_token') === null) {
						const provider = new firebase.auth.OAuthProvider(environment.authService);
						firebase.auth().currentUser.reauthenticateWithRedirect(provider);
					}

					this.checkifStaffIsExisting(user.email.toLowerCase());
				});
			}
		});
	}

	/**
   * @description Checking the existance of the logged in Staff user
   * @param docId (String) facultu document id
   */
	private checkifStaffIsExisting(docId) {
		this.loaderService.show();
		this.dataService.getStaffDetails(docId).pipe(take(1)).subscribe(
			(staffDetails: any) => {
				if (staffDetails) {
					this.staffData = staffDetails;
					this.dataService.setStaffData(staffDetails);
					// If existing Staff
					this.updateExistingUser(this.currentUser, staffDetails);
				} else {
					// new Staff user
					this.createStaff(this.currentUser);
				}
				this.loaderService.hide();
			},
			(error) => {
				this.loaderService.hide();
			}
		);
	}

	// update existing user
	public updateExistingUser(currentUser, staffDetails) {
		try {
			this.dataService.updateExistingStaff(currentUser);
			this.loaderService.show();
			this.dataService.getStaffDetails(currentUser.email).subscribe(
				(staffDetails: any) => {
					this.dataService.setStaffData(staffDetails);
					this.loaderService.hide();
				},
				(error) => {
					this.loaderService.hide();
				}
			);
		} catch (err) {}
	}

	// create Staff Doc
	public createStaff(currentUser) {
		this.generateNewUserTemplate(currentUser);
	}

	/**
   * @description Will Creat new user doc for new user
   * @param currentUser (Object) current logged in user information
   */
	public generateNewUserTemplate(currentUser) {
		const outhData = {
			l: currentUser.l,
			o: currentUser.o,
			refreshToken: currentUser.refreshToken,
			photoURL: currentUser.photoURL,
			emailVerified: currentUser.emailVerified,
			tenantId: currentUser.tenantId,
			metadata: currentUser.metadata,
			providerData: currentUser.providerData[0]
		};

		const staff = {
			uid: currentUser.uid,
			upn: currentUser.email.toLowerCase(),
			oauth_data: JSON.parse(JSON.stringify(outhData)),
			display_name: currentUser.displayName,
			auth_token: currentUser.decodedAuthToken
		};

		/* get subtasks, total_duration_avg, max, min etc and save to fierstore */
		this.generateNewUserData(staff);
	}

	/**
   * @description Will simply save the passed object to firestore
   * @param student (Object) New studnt doc object
   */
	public generateNewUserData(staff) {
		this.loaderService.show();
		this.dataService.insertNewStudentData(staff).then((result) => {
			this.dataService.setStaffData(staff);
			this.staffData = staff;
			this.loaderService.hide();
		});
	}
}
